import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from 'src/app/service/api.service';

@Component({
  selector: 'app-empresas',
  templateUrl: './empresas.component.html',
  styleUrls: ['./empresas.component.css']
})
export class EmpresasComponent implements OnInit {
  jsonArrayDescricao: any;
  descricao: string = '';

  constructor(private apiService: ApiService, private spinner: NgxSpinnerService, private router: Router) { }

  ngOnInit() {
    this.spinner.show();
    this.apiService.getListagem('lojistascertificados')
      .subscribe(
        (data) => { //start of (1)

          this.jsonArrayDescricao = data;

          this.spinner.hide();

          //this.getGeolocation();

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  carregarAvaliacao(e){
    this.router.navigate(['/classificacao', e.lojistaid]);
  }
}
